import React from 'react';
import { Button } from '@/components/ui/button';

const SHOWN = [['status', 'Statut'], ['tour_type', 'Prestation'], ['start_time', 'Début'], ['loading_time', 'Chargement'],
  ['end_time', 'Fin'], ['comment', 'Commentaire'], ['admin_comment', 'Commentaire admin'], ['validation_status', 'Validation'],
  ['site_name', 'Site'], ['mission_source', 'Origine'], ['created_at', 'Créée le'], ['updated_at', 'Modifiée le'],
  ['updated_by_name', 'Modifiée par']];
const LABELS = { prevu: 'Prévu', present: 'Présent', absent: 'Absent', repos: 'Repos', repos_force: 'Repos forcé',
  repos_demande: 'Repos demandé', conge: 'Congé', maladie: 'Maladie', en_cours_integration: "En cours d'intégration",
  pending: 'En attente', validated: 'Validée', approved: 'Validée', rejected: 'Refusée', admin_manual: 'Saisie manager' };
const isIso = (v) => typeof v === 'string' && /^\d{4}-\d{2}-\d{2}T/.test(v);
const fmt = (v) => {
  if (v === null || v === undefined || v === '') return '—';
  if (isIso(v)) return new Date(v).toLocaleString('fr-FR');
  return LABELS[v] || String(v);
};
const day = (d) => new Date(`${d}T12:00:00`).toLocaleDateString('fr-FR');
const reasonLabel = (r) => (r === 'duplicate_resolution' ? 'doublon écarté'
  : r?.startsWith('replaced_by_restore') ? 'remplacée par une restauration' : r);

export const DuplicateGroup = ({ group, onKeep }) => (
  <div className="overflow-x-auto rounded-lg border border-slate-200 bg-white p-3" data-testid={`dup-group-${group.user_id}-${group.date}`}>
    <p className="mb-2 font-semibold">{group.user_name || group.user_id} — {day(group.date)} · {group.rows.length} versions</p>
    <table className="w-full text-xs">
      <thead>
        <tr>
          <th className="p-1 text-left text-slate-500">Champ</th>
          {group.rows.map((r, i) => (
            <th key={r.schedule_id} className="p-1 text-left">
              Version {i + 1}
              {r.schedule_id === group.displayed_schedule_id && <span className="ml-1 rounded bg-blue-100 px-1 text-blue-800">affichée</span>}
              <span className="block font-normal text-slate-400">{r.schedule_id}</span>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {SHOWN.map(([f, label]) => {
          const diff = group.different_fields.includes(f);
          return (
            <tr key={f} className={diff ? 'bg-amber-200 font-semibold text-amber-950' : ''} data-diff={diff}>
              <td className="p-1 text-slate-600">{label}{diff ? ' ≠' : ''}</td>
              {group.rows.map((r) => <td key={r.schedule_id} className="p-1">{fmt(r[f])}</td>)}
            </tr>
          );
        })}
        <tr>
          <td />
          {group.rows.map((r) => (
            <td key={r.schedule_id} className="p-1">
              <Button size="sm" onClick={() => onKeep(group, r.schedule_id)} data-testid={`dup-keep-${r.schedule_id}`}>Conserver celle-ci</Button>
            </td>
          ))}
        </tr>
      </tbody>
    </table>
  </div>
);

export const ArchiveList = ({ records, onRestore }) => (
  <div className="space-y-2">
    {records.length === 0 && <p className="text-sm text-slate-500">Aucune version archivée.</p>}
    {records.map((r) => (
      <div key={r.archive_id} className="flex flex-wrap items-center gap-3 rounded border bg-white p-2 text-sm" data-testid={`archive-${r.archive_id}`}>
        <span className="font-medium">{r.row?.user_name || r.user_id} — {day(r.date)}</span>
        <span className="text-slate-600">{fmt(r.row?.status)} · {fmt(r.row?.tour_type)}</span>
        <span className="text-xs text-slate-500">archivée le {new Date(r.archived_at).toLocaleString('fr-FR')} par {fmt(r.archived_by_name)} ({reasonLabel(r.reason)})</span>
        {r.restored_at
          ? <span className="ml-auto text-xs text-emerald-700">restaurée</span>
          : <Button size="sm" variant="outline" className="ml-auto" onClick={() => onRestore(r)} data-testid={`archive-restore-${r.archive_id}`}>Restaurer</Button>}
      </div>
    ))}
  </div>
);

export const LostEntries = ({ entries }) => (
  <div className="mt-3 space-y-1" data-testid="lost-entries">
    {entries.length === 0 && <p className="text-sm text-emerald-700">Aucune saisie confirmée n’a disparu sur cette période.</p>}
    {entries.map((e) => (
      <div key={`${e.user_id}|${e.date}`} className="rounded border bg-white p-2 text-xs" data-testid={`lost-entry-${e.user_id}-${e.date}`}>
        <span className="font-medium">{e.user_name || e.user_id} — {day(e.date)}</span> · enregistré « {fmt(e.saved_status)} » par {fmt(e.by)} le {new Date(e.at).toLocaleString('fr-FR')}
        {' '}→ aujourd’hui « {fmt(e.current_status)} »{e.current_updated_by ? ` (modifié par ${e.current_updated_by})` : ''}
        {e.reason === 'row_missing' && <span className="ml-1 font-semibold text-red-700">ligne absente</span>}
      </div>
    ))}
  </div>
);
